module.exports = function findEntityDates(attributes, config) {
	//check if 'config' is empty
  if (typeof(config)!=="undefined" && config.type === "node--page") return;
	let dates;
	if (attributes.field_start_date) {
		dates = [];
		dates = [attributes.field_start_date];
		if (attributes.field_end_date) {
			dates.push(attributes.field_end_date);
		}
	}
	if (!dates && config && config.dateFormat) {
		dates = [attributes.created];
	}
	return dates;
};
